import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "agenda-view-page"
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-light font-weight-bolder font-size-sm",
    attrs: {
      "to": {
        name: 'crmAgenda'
      }
    }
  }, [_vm._v(" Voltar ")])], 1)]), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('div', {
    staticClass: "agenda-filter-band mb-8"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Usuário"
    }
  }, [_vm.canManageAgendaUsers ? _c('VueSelect', {
    ref: "buscarUsuario",
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.usuarios,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setUsuario,
      "search": _vm.onSearchUsuario
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.nome) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.nome) + " ")];
      }
    }], null, false, 4041025997),
    model: {
      value: _vm.usuario,
      callback: function callback($$v) {
        _vm.usuario = $$v;
      },
      expression: "usuario"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do usuário ")])], 2) : _c('b-form-input', {
    attrs: {
      "value": _vm.usuarioLabel(_vm.currentUserAgendaUser),
      "disabled": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    on: {
      "change": _vm.changeDate
    },
    model: {
      value: _vm.data,
      callback: function callback($$v) {
        _vm.data = $$v;
      },
      expression: "data"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Visualização"
    }
  }, [_c('div', {
    staticClass: "agenda-view-toggle"
  }, [_c('button', {
    staticClass: "agenda-view-option",
    class: {
      active: _vm.viewMode === 'day'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.setViewMode('day');
      }
    }
  }, [_vm._v(" Diária ")]), _c('button', {
    staticClass: "agenda-view-option",
    class: {
      active: _vm.viewMode === 'week'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.setViewMode('week');
      }
    }
  }, [_vm._v(" Semanal ")])])])], 1), _c('b-col', {
    staticClass: "agenda-filter-actions",
    attrs: {
      "md": "12",
      "lg": "12"
    }
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Hoje',
      expression: "'Hoje'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setToday
    }
  }, [_c('CalendarToday', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Bloqueio de agenda',
      expression: "'Bloqueio de agenda'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openBloqueioModal
    }
  }, [_c('CalendarLock', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Configurações',
      expression: "'Configurações'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openConfiguracaoModal
    }
  }, [_c('Cog', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Gerar link',
      expression: "'Gerar link'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openLinkModal
    }
  }, [_c('LinkVariant', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    staticClass: "btn btn-light agenda-search-button font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSearchAgenda || _vm.loadingHorarios
    },
    on: {
      "click": _vm.buscarAgendas
    }
  }, [_c('Magnify', {
    staticClass: "mr-1",
    attrs: {
      "size": 18
    }
  }), _vm._v(" " + _vm._s(_vm.loadingHorarios ? "Buscando..." : "Buscar agendas") + " ")], 1)])], 1)], 1), !_vm.canShowAgenda ? _c('div', {
    staticClass: "agenda-empty"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v("Selecione um usuário")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Depois da seleção, a agenda aparece com horários livres e ocupados. ")])]) : _c('b-row', [_c('b-col', {
    attrs: {
      "md": _vm.viewMode === 'week' ? 9 : 8
    }
  }, [_c('div', {
    staticClass: "agenda-calendar-header"
  }, [_c('button', {
    staticClass: "btn btn-light btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(-_vm.navigationStep);
      }
    }
  }, [_c('ChevronLeft', {
    attrs: {
      "size": 20
    }
  })], 1), _c('div', {
    staticClass: "agenda-date-title"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.headerTitle))]), _c('div', {
    staticClass: "agenda-day-meta"
  }, [_c('span', [_vm._v("Expediente configurado")]), _c('span', [_vm._v("Blocos de 15 min")]), _c('span', [_vm._v(_vm._s(_vm.availableSlotsCount) + " horários livres")])])]), _c('button', {
    staticClass: "btn btn-light btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(_vm.navigationStep);
      }
    }
  }, [_c('ChevronRight', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.searchingNextAvailable
    },
    on: {
      "click": _vm.goToNextAvailableDate
    }
  }, [_vm._v(" " + _vm._s(_vm.searchingNextAvailable ? "Buscando..." : "Próximo disponível") + " ")])]), _vm.loadingHorarios ? _c('div', {
    staticClass: "agenda-loading"
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Carregando agenda... ")], 1) : _vm.horariosError ? _c('div', {
    staticClass: "alert alert-light-danger"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.horariosError))]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadAgenda
    }
  }, [_vm._v(" Tentar novamente ")])])]) : _vm.viewMode === 'day' ? [_vm.horarios.expediente && _vm.horarios.expediente.fechado ? _c('div', {
    staticClass: "alert alert-light-warning"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v("Domingo não possui expediente padrão.")]), _c('button', {
    staticClass: "btn btn-sm btn-light-warning font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(1);
      }
    }
  }, [_vm._v(" Próximo dia ")])])]) : !_vm.hasSlots ? _c('div', {
    staticClass: "agenda-empty"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v(" Nenhum horário foi recebido. ")]), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v(" Tente recarregar a agenda ou escolha outro dia. ")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadAgenda
    }
  }, [_vm._v(" Recarregar ")]), _c('button', {
    staticClass: "btn btn-light font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.moveDate(1);
      }
    }
  }, [_vm._v(" Próximo dia ")])]) : _c('div', [!_vm.hasAvailableSlots ? _c('div', {
    staticClass: "agenda-empty mb-5"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v(" Dia sem horários disponíveis. ")]), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v(" Todos os horários deste usuário estão ocupados. ")]), _c('button', {
    staticClass: "btn btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToNextAvailableDate
    }
  }, [_vm._v(" Buscar próximo disponível ")])]) : _vm._e(), _vm._l(_vm.slotGroups, function (group) {
    return _c('div', {
      key: group.label,
      staticClass: "agenda-period"
    }, [_c('div', {
      staticClass: "agenda-period-title"
    }, [_c('h5', [_vm._v(_vm._s(group.label))]), _c('span', [_vm._v(" " + _vm._s(group.available) + " livres de " + _vm._s(group.total) + " ")])]), _c('div', {
      staticClass: "agenda-slots"
    }, _vm._l(group.slots, function (slot) {
      return _c('div', {
        key: slot.inicio,
        staticClass: "agenda-slot",
        class: {
          unavailable: !slot.disponivel
        },
        attrs: {
          "title": _vm.slotTitle(slot)
        }
      }, [_c('ClockOutline', {
        attrs: {
          "size": 16
        }
      }), _c('span', [_vm._v(_vm._s(_vm.slotLabel(slot)))]), _c('small', [_vm._v(_vm._s(_vm.slotStatusLabel(slot)))]), _vm.isBloqueioSlot(slot) ? _c('strong', {
        staticClass: "agenda-slot-client"
      }, [_vm._v(" Bloqueado ")]) : slot.ocupado ? _c('strong', {
        staticClass: "agenda-slot-client"
      }, [_vm._v(" " + _vm._s(slot.ocupado.cliente || "Cliente") + " ")]) : _vm._e(), slot.ocupado && !_vm.isBloqueioSlot(slot) ? _c('em', [_vm._v(" " + _vm._s(_vm.ocupadoServico(slot.ocupado)) + " ")]) : _vm._e()], 1);
    }), 0)]);
  })], 2)] : [!_vm.hasWeekData ? _c('div', {
    staticClass: "agenda-empty"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v(" Nenhum horário foi recebido. ")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Tente recarregar a agenda semanal ou escolha outra data. ")])]) : _c('div', {
    staticClass: "agenda-week-wrapper"
  }, [_c('div', {
    staticClass: "agenda-week-grid agenda-week-header"
  }, [_c('div', {
    staticClass: "agenda-week-time-header"
  }), _vm._l(_vm.weekDays, function (day) {
    return _c('div', {
      key: day.date,
      staticClass: "agenda-week-day-header",
      class: {
        closed: _vm.isWeekDayClosed(day.date),
        selected: day.date === _vm.selectedDate
      }
    }, [_c('strong', [_vm._v(_vm._s(day.label))]), _c('span', [_vm._v(_vm._s(day.shortDate))]), _vm.isWeekDayClosed(day.date) ? _c('small', [_vm._v("Fechado")]) : _vm._e()]);
  })], 2), _c('div', {
    staticClass: "agenda-week-grid agenda-week-body",
    style: _vm.weekGridStyle
  }, [_vm._l(_vm.weekTimeRows, function (time, rowIndex) {
    return [_c('div', {
      key: "time-".concat(time),
      staticClass: "agenda-week-time",
      style: {
        gridRow: rowIndex + 1
      }
    }, [_vm._v(" " + _vm._s(time) + " ")]), _vm._l(_vm.weekDays, function (day, dayIndex) {
      return _c('div', {
        key: "".concat(day.date, "-").concat(time),
        staticClass: "agenda-week-cell",
        class: _vm.weekCellClass(day.date, time),
        style: {
          gridColumn: dayIndex + 2,
          gridRow: rowIndex + 1
        }
      });
    })];
  }), _vm._l(_vm.weekEvents, function (event) {
    return _c('div', {
      key: event.key,
      staticClass: "agenda-week-event",
      class: {
        'is-short': event.isShort,
        'is-blocked': event.isBlocked
      },
      style: {
        gridColumn: event.column,
        gridRow: event.row,
        borderLeftColor: event.color,
        backgroundColor: event.background,
        '--lane-index': event.laneIndex,
        '--lane-count': event.laneCount
      },
      attrs: {
        "title": event.title
      }
    }, [event.isBlocked ? [_c('span', [_vm._v("Bloqueado")])] : event.isShort ? [_c('strong', [_vm._v(_vm._s(event.shortTime))]), _c('span', [_vm._v(_vm._s(event.cliente))])] : !event.isBlocked ? [_c('strong', [_vm._v(_vm._s(event.time))]), _c('span', [_vm._v(_vm._s(event.cliente))]), event.usuario ? _c('small', [_vm._v(_vm._s(event.usuario))]) : _vm._e(), _c('small', [_vm._v(_vm._s(event.servico))])] : _vm._e()], 2);
  })], 2)])]], 2), _c('b-col', {
    attrs: {
      "md": _vm.viewMode === 'week' ? 3 : 4
    }
  }, [_c('div', {
    staticClass: "agenda-panel"
  }, [_c('h5', {
    staticClass: "font-weight-bolder mb-4"
  }, [_vm._v(_vm._s(_vm.summaryTitle))]), _c('p', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Usuário:")]), _vm._v(" " + _vm._s(_vm.summaryUserLabel) + " ")]), _c('p', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.viewMode === "week" ? "Período" : "Data") + ":")]), _vm._v(" " + _vm._s(_vm.summaryDateLabel) + " ")]), _c('div', {
    staticClass: "agenda-summary-grid mb-5"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.totalSlotsCount))]), _c('span', [_vm._v("Total")])]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.availableSlotsCount))]), _c('span', [_vm._v("Livres")])]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.busySlotsCount))]), _c('span', [_vm._v("Ocupados")])])]), _vm.canManageAgendaUsers && _vm.viewMode === 'week' ? _c('div', {
    staticClass: "agenda-user-filter mb-5"
  }, [_c('div', {
    staticClass: "agenda-user-filter-header"
  }, [_c('h6', {
    staticClass: "font-weight-bolder mb-0"
  }, [_vm._v("Usuários")]), _vm.hasPendingUserSelection ? _c('small', [_vm._v("Seleção alterada")]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-light btn-sm btn-block agenda-select-all",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleTodosUsuariosAgenda
    }
  }, [_vm._v(" " + _vm._s(_vm.todosUsuariosSelecionados ? "Desmarcar todos" : "Selecionar todos") + " ")]), _vm._l(_vm.usuarios, function (usuarioItem) {
    return _c('label', {
      key: usuarioItem.id_usuario,
      staticClass: "agenda-user-check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedUserIds,
        expression: "selectedUserIds"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": usuarioItem.id_usuario,
        "checked": Array.isArray(_vm.selectedUserIds) ? _vm._i(_vm.selectedUserIds, usuarioItem.id_usuario) > -1 : _vm.selectedUserIds
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.selectedUserIds,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = usuarioItem.id_usuario,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedUserIds = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedUserIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedUserIds = $$c;
          }
        }
      }
    }), _c('span', {
      staticClass: "agenda-user-color",
      style: {
        backgroundColor: _vm.usuarioColor(usuarioItem)
      }
    }), _vm._v(" " + _vm._s(_vm.usuarioLabel(usuarioItem)) + " ")]);
  }), _c('button', {
    staticClass: "btn btn-light-primary btn-block font-weight-bold mt-4",
    attrs: {
      "type": "button",
      "disabled": !_vm.canSearchAgenda || _vm.loadingHorarios
    },
    on: {
      "click": _vm.buscarAgendas
    }
  }, [_c('Magnify', {
    staticClass: "mr-1",
    attrs: {
      "size": 18
    }
  }), _vm._v(" " + _vm._s(_vm.loadingHorarios ? "Buscando..." : "Buscar agendas") + " ")], 1), _c('small', {
    staticClass: "text-muted d-block mt-2"
  }, [_vm._v(" Marque os usuários e clique para atualizar a agenda. ")])], 2) : _vm._e(), _vm.viewMode === 'day' ? [_c('h6', {
    staticClass: "font-weight-bolder mb-3"
  }, [_vm._v(_vm._s(_vm.busyListTitle))]), _vm.busyAppointments.length === 0 ? _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Nenhum agendamento ocupando este dia. ")]) : _vm._e(), _vm._l(_vm.busyAppointments, function (ocupado) {
    return _c('div', {
      key: "".concat(ocupado.id_agendamento, "-").concat(ocupado.data_inicio),
      staticClass: "agenda-busy-item"
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatTime(ocupado.data_inicio)) + " - " + _vm._s(_vm.formatTime(ocupado.data_fim)) + " ")]), _c('span', [_vm._v(_vm._s(ocupado.cliente || "Cliente"))]), ocupado.telefone ? _c('small', [_vm._v(" Telefone: " + _vm._s(ocupado.telefone) + " ")]) : _vm._e(), _c('small', [_vm._v(_vm._s(_vm.ocupadoServico(ocupado)))]), ocupado.observacoes ? _c('small', [_vm._v(" " + _vm._s(ocupado.observacoes) + " ")]) : _vm._e()]);
  })] : _vm._e()], 2)])], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "agendaBloqueioModal",
      "centered": "",
      "title": "Bloqueio de agenda",
      "ok-title": "Bloquear",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.salvarBloqueio
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Início"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.bloqueioForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.bloqueioForm, "data_inicio", $$v);
      },
      expression: "bloqueioForm.data_inicio"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Fim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.bloqueioForm.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.bloqueioForm, "data_fim", $$v);
      },
      expression: "bloqueioForm.data_fim"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Motivo"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.bloqueioForm.motivo,
      callback: function callback($$v) {
        _vm.$set(_vm.bloqueioForm, "motivo", $$v);
      },
      expression: "bloqueioForm.motivo"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "agendaConfiguracaoModal",
      "centered": "",
      "size": "lg",
      "title": "Configurações da agenda",
      "ok-title": "Salvar",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.salvarConfiguracao
    }
  }, _vm._l(_vm.diasSemana, function (dia) {
    return _c('div', {
      key: dia.key,
      staticClass: "agenda-config-day"
    }, [_c('div', {
      staticClass: "agenda-config-day-header"
    }, [_c('strong', [_vm._v(_vm._s(dia.label))]), _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.addExpedienteBloco(dia.key);
        }
      }
    }, [_vm._v(" Adicionar ")])]), _vm._l(_vm.configForm.expedientes[dia.key], function (bloco, index) {
      return _c('div', {
        key: "".concat(dia.key, "-").concat(index),
        staticClass: "agenda-config-block"
      }, [_c('b-form-input', {
        attrs: {
          "type": "time"
        },
        model: {
          value: bloco.inicio,
          callback: function callback($$v) {
            _vm.$set(bloco, "inicio", $$v);
          },
          expression: "bloco.inicio"
        }
      }), _c('b-form-input', {
        attrs: {
          "type": "time"
        },
        model: {
          value: bloco.fim,
          callback: function callback($$v) {
            _vm.$set(bloco, "fim", $$v);
          },
          expression: "bloco.fim"
        }
      }), _c('button', {
        staticClass: "btn btn-sm btn-light-danger font-weight-bold",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.removeExpedienteBloco(dia.key, index);
          }
        }
      }, [_vm._v(" Remover ")])], 1);
    }), _vm.configForm.expedientes[dia.key].length === 0 ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" Sem expediente ")]) : _vm._e()], 2);
  }), 0), _c('b-modal', {
    attrs: {
      "id": "agendaLinkModal",
      "centered": "",
      "size": "lg",
      "title": "Gerar link de agenda",
      "ok-title": "Gerar link",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.gerarLinkAgenda
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.clientes,
      "clearSearchOnSelect": true
    },
    on: {
      "search": _vm.onSearchCliente
    },
    model: {
      value: _vm.linkForm.cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "cliente", $$v);
      },
      expression: "linkForm.cliente"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do cliente")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.linkForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "data_inicio", $$v);
      },
      expression: "linkForm.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.linkForm.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "data_fim", $$v);
      },
      expression: "linkForm.data_fim"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Duração"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1440"
    },
    model: {
      value: _vm.linkForm.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "duracao_minutos", _vm._n($$v));
      },
      expression: "linkForm.duracao_minutos"
    }
  })], 1)], 1)], 1), _vm.linkGerado ? _c('div', {
    staticClass: "alert alert-light-success mb-0"
  }, [_c('strong', [_vm._v("Link gerado:")]), _c('div', {
    staticClass: "agenda-link-result"
  }, [_vm._v(_vm._s(_vm.linkGerado))])]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v("Agenda")]), _c('span', {
    staticClass: "text-muted mt-2 font-weight-bold font-size-sm"
  }, [_vm._v(" Visualize horários livres e ocupados da agenda. ")])]);
}];
export { render, staticRenderFns };